import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { OrderForListing } from '../../models/OrderForListing';

interface IOrderFulfillmentPopoverProps {
  orderForListing: OrderForListing;
}

export const OrderFulfillmentPopover: React.FC<IOrderFulfillmentPopoverProps> = ({
  orderForListing
}) => {

  let backgroundColor = '#ababe3';
  if (orderForListing?.order?.isCrossChannelSale) {
    backgroundColor = '#7979c1';
  }

  let tooltipText = '';  
  if (orderForListing.order.locationId === 1) {
    tooltipText = 'Entregue por e-commerce';
  } else {
    tooltipText = 'Entregue por loja';
  }
  if (orderForListing.order.isCrossChannelSale && orderForListing.order.originLocationId) {
    tooltipText += ` e com origem na loja ${orderForListing.originLocationForCrossChannelSale?.name || ' de ID ' + orderForListing.order.originLocationId}`;
  }

  return (
    <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={<Tooltip>{tooltipText}</Tooltip>}
    >
      <span style={{ color: '#fff', backgroundColor: backgroundColor,
        borderRadius: '2px', height: '16px', maxHeight: '16px', 
        width: '14px', minWidth: '14px', display: 'flex', 
        justifyContent: 'center', alignItems: 'center',
        fontSize: '0.65em'
      }}
      >
        {orderForListing.order.locationId === 1 ? 'E' : 'L'}
      </span>
    </OverlayTrigger>
  );

}